import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css']
})
export class PrivacyComponent implements OnInit {

  constructor() { }

  classname = "footer-area footer-area-2 footer-area-1 bg_cover";
  ftbgimage = "assets/images/footer-bg.jpg";
  ftlogo = "assets/images/logo-1.1.png";
  ftshape = "d-none";

  show: boolean;
  public innerWidth: any;
  mn;

  ngOnInit(): void {
    this.mn = sessionStorage.getItem('lang') == 'mn';
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 769) {
      this.show = true;
    }

  }

}
